import React from "react";
import {getAttachmentsPath} from "../Util";
import {selectApp} from "../app/appSlice";
import {useParams} from "react-router-dom";
import Attachments from "../../components/Attachments";
import {selectSession} from "../session/sessionSlice";
import {useSelector} from "react-redux";

export default function AttachmentPage() {

  const {reservationNo, email} = useParams();

  const {
    instance,
    customerBusy,
  } = useSelector(
    state => ({
      reservation: selectSession(state).reservation,
      busy: selectSession(state).fetchBusy,
      site: selectApp(state).site,
      customer: selectApp(state).customer,
      customerBusy: selectApp(state).busy,
      instance: selectApp(state).instance,
    }));

  return (
    <>
      {!customerBusy && <div className={"bn-confirmation-container"}>
        <h1>Attachments</h1>
        <div className={"bn-attachments-page-container"}>
          <p>
            Please find attachments for reservation
            no. <strong>{`${reservationNo}`}</strong> below:
          </p>

          <div className={"confirmation-attachments"}>
            <Attachments
              viewOnly={true}
              path={getAttachmentsPath(instance, reservationNo)}
              onSuccess={() => {
              }}
            />
          </div>
        </div>
      </div>}
    </>
  )
}